/**
 * @generated SignedSource<<30482d89e3ee1e0bec019b2a49b99f1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type FeatureKind = "EXPERIMENT" | "OPS" | "RELEASE" | "%future added value";
export type FeatureStage = "BETA" | "GA" | "INTERNAL" | "OFF" | "%future added value";
export type featureFlagMutationsSetKilledMutation$variables = {
  key: FeatureKey;
  killed: boolean;
};
export type featureFlagMutationsSetKilledMutation$data = {
  readonly setKilled: {
    readonly key: FeatureKey;
    readonly killed: boolean;
    readonly kind: FeatureKind;
    readonly percent: number;
    readonly stage: FeatureStage;
  };
};
export type featureFlagMutationsSetKilledMutation = {
  response: featureFlagMutationsSetKilledMutation$data;
  variables: featureFlagMutationsSetKilledMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "killed"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      },
      {
        "kind": "Variable",
        "name": "killed",
        "variableName": "killed"
      }
    ],
    "concreteType": "FeatureFlagState",
    "kind": "LinkedField",
    "name": "setKilled",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "killed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "featureFlagMutationsSetKilledMutation",
    "selections": (v1/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "featureFlagMutationsSetKilledMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c4e11d6e255210d2fc016bed20fb256a",
    "id": null,
    "metadata": {},
    "name": "featureFlagMutationsSetKilledMutation",
    "operationKind": "mutation",
    "text": "mutation featureFlagMutationsSetKilledMutation(\n  $key: FeatureKey!\n  $killed: Boolean!\n) {\n  setKilled(key: $key, killed: $killed) {\n    key\n    stage\n    killed\n    percent\n    kind\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb84e804e70a7a1489d4bca42f689aa2";

export default node;
